<lcs-loading-overlay
   class="flex-dir-col"
   [show]="callState | lcsCallState : 'loading'"
   *ndtErrorPage="!(callState | lcsCallState : 'error'); entityName: 'Extension'"
>
   <div class="detail-page-headerbar">
      <div class="left">
         <div class="page-heading">
            @if (extension?.extensionId && idsFromRegister?.length > 0) {
            <div class="nav-buttons">
               <button [disabled]="!hasNavigateUp" mat-icon-button (click)="onNavigateUp()">
                  <mat-icon>keyboard_arrow_left</mat-icon>
               </button>
               <span class="detail-index">{{ indexDisplay }}</span>
               <button [disabled]="!hasNavigateDown" mat-icon-button (click)="onNavigateDown()">
                  <mat-icon>keyboard_arrow_right</mat-icon>
               </button>
            </div>
            }
            <h2 class="page-title">
               {{ extension?.number }} - {{ extension?.name }}
               @if ( isSystemUser && hackedFraudDetails && (hackedFraudDetails.isHacked === true ||
               hackedFraudDetails.isFraud === true) ) {
               <phone-issues-chip-and-menu
                  class="issues-chip"
                  [hackedFraudDetails]="hackedFraudDetails"
               ></phone-issues-chip-and-menu>
               }
            </h2>
         </div>
      </div>
      <div class="right context-actions">
         <button
            type="button"
            mat-button
            [matMenuTriggerFor]="updateDetailsMenu"
            matTooltip="Info"
            aria-label="Extension Info"
            id="extension-detail-info"
         >
            <mat-icon>info</mat-icon>
         </button>
         @if ( extension?.type.name !== extensionTypes.Phone || isSystemUser || (isSystemUser && hackedFraudDetails &&
         (hackedFraudDetails.isHacked || hackedFraudDetails.isFraud)) ) {
         <button
            type="button"
            mat-button
            [matMenuTriggerFor]="extensionMenu"
            aria-label="Extension Actions"
            matTooltip="More Actions"
            id="extension-detail-more-actions"
         >
            <mat-icon>more_horiz</mat-icon>
         </button>
         }
      </div>
   </div>

   <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <ndt-two-column-layout>
         <div ndtLeftColumn>
            <div class="details-wrapper">
               <h4 class="">{{ extension?.type?.displayName }}</h4>

               @switch (extension?.type?.name) { @case (extensionTypes.Phone) {
               <ndt-extension-phone-detail-left-column
                  [extensionPhone]="extension.extensionPhone"
                  [timeZoneId]="extension.timeZoneId"
                  [dndStatus]="form.get('extensionPhone.dndStatus').value"
                  [domain]="extension.account.domain"
                  [isSystemUser]="isSystemUser"
                  (changeDNDStatus)="onChangeDNDStatus($event)"
               ></ndt-extension-phone-detail-left-column>
               } @case (extensionTypes.AutoAttendant) {
               <ndt-extension-auto-attendant-detail-left-column
                  [extensionAutoAttendant]="extension.extensionAutoAttendant"
               ></ndt-extension-auto-attendant-detail-left-column>
               } @case (extensionTypes.HuntGroup) {
               <ndt-extension-hunt-group-detail-left-column
                  [extensionHuntGroup]="extension.extensionHuntGroup"
               ></ndt-extension-hunt-group-detail-left-column>
               } @case (extensionTypes.ExternalForward) {
               <ndt-extension-external-forward-detail-left-column
                  [extensionExternalForward]="extension.extensionExternalForward"
               ></ndt-extension-external-forward-detail-left-column>
               } @case (extensionTypes.VoiceMailbox) {
               <ndt-extension-mail-box-detail-left-column
                  [extensionMailbox]="extension.extensionMailbox"
                  [timeZoneId]="extension.timeZoneId"
               ></ndt-extension-mail-box-detail-left-column>
               } @case (extensionTypes.SmartVoicemail) {
               <ndt-extension-mail-box-detail-left-column
                  [extensionMailbox]="extension.extensionMailbox"
                  [timeZoneId]="extension.timeZoneId"
               ></ndt-extension-mail-box-detail-left-column>
               } @case (extensionTypes.CallQueue) {
               <ndt-extension-queue-detail-left-column
                  [extensionQueue]="extension.extensionQueue"
               ></ndt-extension-queue-detail-left-column>
               } @case (extensionTypes.Fax) {
               <ndt-extension-fax-detail-left-column
                  [extensionFax]="extension.extensionFax"
               ></ndt-extension-fax-detail-left-column>
               } @case (extensionTypes.FindMeFollowMe) {
               <ndt-extension-fmfm-detail-left-column
                  [extensionFmFm]="extension.extensionFmFm"
               ></ndt-extension-fmfm-detail-left-column>
               } @case (extensionTypes.PagingGroup) {
               <ndt-extension-paging-group-detail-left-column
                  [extensionPagingGroup]="extension.extensionPagingGroup"
               ></ndt-extension-paging-group-detail-left-column>
               } }
            </div>
         </div>

         <div ndtRightColumn>
            <mat-tab-group
               class="detail-tab-group"
               [(selectedIndex)]="selectedIndex"
               (selectedTabChange)="onTabChange($event)"
               ndt-tab-router
               [loadSuccess$]="loadSuccess$"
            >
               <mat-tab [label]="'Extension'">
                  <div class="mat-tab-indented">
                     <div class="detail-right-column">
                        <div class="flex-full">
                           @switch (extension?.type?.name) { @case (extensionTypes.Phone) {
                           <ndt-extension-phone-details
                              [extensionPhone]="extension.extensionPhone"
                              [timeZoneId]="extension.timeZoneId"
                              [accountId]="extension.account?.accountId"
                              [extensionId]="extension.extensionId"
                              [canEdit]="canEdit()"
                              (addExtensionSupervisee)="addExtensionSuperviseeClick($event)"
                              [extension]="extension"
                              [externalNumbers]="externalNumbers"
                              [extensionPrivileges]="extensionPrivileges"
                              [accountIsOtrEnabled]="extension.accountIsOtrEnabled"
                              [accountIsCallRecordingFeatureEnabled]="extension.accountIsCallRecordingFeatureEnabled"
                              [isSystemUser]="isSystemUser"
                              [parentFormGroup]="form"
                              formGroupName="extensionPhone"
                           ></ndt-extension-phone-details>
                           } @case (extensionTypes.AutoAttendant) {
                           <ndt-extension-auto-attendant-details
                              [extensionAutoAttendant]="extension.extensionAutoAttendant"
                              [extension]="extension"
                              [parentFormGroup]="form"
                              [isSystemUser]="isSystemUser"
                              [accountId]="extension.account?.accountId"
                              [extensionId]="extension.extensionId"
                              [extensionPrivileges]="extensionPrivileges"
                              formGroupName="extensionAutoAttendant"
                           ></ndt-extension-auto-attendant-details>
                           } @case (extensionTypes.ExternalForward) {
                           <ndt-extension-external-forward-details
                              [extensionExternalForward]="extension.extensionExternalForward"
                              [accountId]="extension.account?.accountId"
                              [extensionPrivileges]="extensionPrivileges"
                              [extension]="extension"
                              [parentFormGroup]="form"
                              [isSystemUser]="isSystemUser"
                              formGroupName="extensionExternalForward"
                           ></ndt-extension-external-forward-details>
                           } @case (extensionTypes.HuntGroup) {
                           <ndt-extension-hunt-group-details
                              [extensionHuntGroup]="extension.extensionHuntGroup"
                              [accountId]="extension.account?.accountId"
                              [extensionId]="extension.extensionId"
                              [extension]="extension"
                              [parentFormGroup]="form"
                              [isSystemUser]="isSystemUser"
                              [canEdit]="canEdit()"
                              formGroupName="extensionHuntGroup"
                           ></ndt-extension-hunt-group-details>
                           } @case (extensionTypes.PagingGroup) {
                           <ndt-extension-paging-group-details
                              [extensionPagingGroup]="extension.extensionPagingGroup"
                              [accountId]="extension.account?.accountId"
                              [extensionId]="extension.extensionId"
                              [extension]="extension"
                              [parentFormGroup]="form"
                              [isSystemUser]="isSystemUser"
                              [canEdit]="canEdit()"
                              formGroupName="extensionPagingGroup"
                           ></ndt-extension-paging-group-details>
                           } @case (extensionTypes.VoiceMailbox) {
                           <ndt-extension-mail-box-details
                              [extensionMailbox]="extension.extensionMailbox"
                              [timeZoneId]="extension.timeZoneId"
                              [accountId]="extension.account?.accountId"
                              [extensionPrivileges]="extensionPrivileges"
                              [extension]="extension"
                              [parentFormGroup]="form"
                              [isSystemUser]="isSystemUser"
                              formGroupName="extensionMailbox"
                           ></ndt-extension-mail-box-details>
                           } @case (extensionTypes.SmartVoicemail) {
                           <ndt-extension-mail-box-details
                              [extensionMailbox]="extension.extensionMailbox"
                              [timeZoneId]="extension.timeZoneId"
                              [accountId]="extension.account?.accountId"
                              [extensionPrivileges]="extensionPrivileges"
                              [extension]="extension"
                              [parentFormGroup]="form"
                              [isSystemUser]="isSystemUser"
                              [extensionType]="extensionTypes.SmartVoicemail"
                              formGroupName="extensionMailbox"
                           ></ndt-extension-mail-box-details>
                           } @case (extensionTypes.CallQueue) {
                           <ndt-extension-queue-details
                              [extension]="extension"
                              [extensionQueue]="extension.extensionQueue"
                              [accountId]="extension.account?.accountId"
                              [extensionId]="extension.extensionId"
                              [parentFormGroup]="form"
                              [isSystemUser]="isSystemUser"
                              [canEdit]="canEdit()"
                              formGroupName="extensionQueue"
                           ></ndt-extension-queue-details>
                           } @case (extensionTypes.Fax) {
                           <ndt-extension-fax-details
                              [extensionFax]="extension.extensionFax"
                              [accountId]="extension.account?.accountId"
                              [extension]="extension"
                              [parentFormGroup]="form"
                              [isSystemUser]="isSystemUser"
                              [canEdit]="canEdit()"
                              formGroupName="extensionFax"
                           ></ndt-extension-fax-details>
                           } @case (extensionTypes.FindMeFollowMe) {
                           <ndt-extension-fmfm-details
                              [extensionFmFm]="extension.extensionFmFm"
                              [accountId]="extension.account?.accountId"
                              [extension]="extension"
                              [parentFormGroup]="form"
                              [isSystemUser]="isSystemUser"
                              formGroupName="extensionFindMeFollowMe"
                              [canEdit]="canEdit()"
                           ></ndt-extension-fmfm-details>
                           } }
                        </div>
                     </div>
                  </div>
               </mat-tab>

               @if (extension?.type.name === extensionTypes.FindMeFollowMe) {
               <mat-tab [label]="'Steps'">
                  <div class="mat-tab-indented">
                     <ng-container formGroupName="extensionFindMeFollowMe">
                        <ndt-find-me-follow-me-steps
                           formControlName="fmFmSteps"
                           [extension]="extension"
                           (addFindMeFollowMeStepClick)="onAddFindMeFollowMeStepClick()"
                           [canEdit]="canEdit()"
                        ></ndt-find-me-follow-me-steps>
                     </ng-container>
                  </div>
               </mat-tab>
               } @if (isSystemUser && phonePrivileges?.canView && extension?.type?.name === extensionTypes.Phone) {
               <mat-tab [label]="'Phones'">
                  <div class="mat-tab-indented">
                     <ng-container formGroupName="extensionPhone">
                        <ndt-extension-phone-register
                           [phonePrivileges]="phonePrivileges"
                           [accountId]="extension?.account?.accountId"
                           [callState]="callState"
                           [form]="form"
                           formControlName="phones"
                        ></ndt-extension-phone-register>
                     </ng-container>
                  </div>
               </mat-tab>
               } @if (extension?.type?.name === extensionTypes.Fax) {
               <mat-tab [label]="'Whitelisted Emails'">
                  <div class="mat-tab-indented">
                     <ng-container>
                        <ndt-fax-emails
                           [form]="form"
                           formControlName="faxEmailAddresses"
                           [extensionId]="extension.extensionId"
                           [extensionPrivileges]="extensionPrivileges"
                           [callState]="callState"
                        ></ndt-fax-emails>
                     </ng-container>
                  </div>
               </mat-tab>
               } @if (extension?.type?.name === extensionTypes.Fax) {
               <mat-tab [label]="'Outgoing Faxes'">
                  <div class="register-tab">
                     <ndt-outgoing-fax-register [extensionId]="extension?.extensionId"></ndt-outgoing-fax-register>
                  </div>
               </mat-tab>
               } @if (extension?.type?.name === extensionTypes.Fax) {
               <mat-tab [label]="'Incoming Faxes'">
                  <div class="register-tab">
                     <ndt-incoming-fax-register [extensionId]="extension?.extensionId"></ndt-incoming-fax-register>
                  </div>
               </mat-tab>
               } @if (extension?.type?.name === extensionTypes.AutoAttendant) {
               <mat-tab [label]="'Prompts'">
                  <div class="mat-tab-indented">
                     <ng-container formGroupName="extensionAutoAttendant">
                        <ndt-auto-attendant-prompt-list
                           [accountId]="extension.account?.accountId"
                           [callState]="callState"
                           [extensionPrivileges]="extensionPrivileges"
                           [firstPromptNotSkippable]="form.get('extensionAutoAttendant.firstPromptNotSkippable')"
                           formControlName="autoAttendantPrompts"
                           (addExistingPromptClick)="onAddExistingAutoAttendantPromptClick()"
                           (addNewPromptClick)="onAddNewAutoAttendantPromptClick()"
                        ></ndt-auto-attendant-prompt-list>
                     </ng-container>
                  </div>
               </mat-tab>
               } @if (extension?.type?.name === extensionTypes.AutoAttendant) {
               <mat-tab [label]="'Key Information'">
                  <div class="mat-tab-indented">
                     <ng-container formGroupName="extensionAutoAttendant">
                        <ndt-auto-attendant-key-list
                           [accountId]="extension.account?.accountId"
                           [extensionId]="extension.extensionId"
                           [callState]="callState"
                           [extensionPrivileges]="extensionPrivileges"
                           [canEdit]="extensionPrivileges.canEditAutoAttendants"
                           [form]="form"
                           formControlName="autoAttendantKeys"
                        ></ndt-auto-attendant-key-list>
                     </ng-container>
                  </div>
               </mat-tab>
               } @if (extension?.type?.name === extensionTypes.CallQueue) {
               <mat-tab [label]="'Queue Calls'">
                  <ndt-queue-history-register [extensionId]="extension?.extensionId"></ndt-queue-history-register>
               </mat-tab>
               } @if (extension?.type?.name === extensionTypes.CallQueue) {
               <mat-tab [label]="'Periodic Announcements'">
                  <div class="mat-tab-indented">
                     <ng-container formGroupName="extensionQueue" style="position: relative">
                        <div class="detail-right-column">
                           <ndt-card [title]="'Default Announcement Settings'" class="detail-card-half">
                              <div class="flex-half">
                                 <mat-form-field class="announcement-frequency">
                                    <mat-label>Frequency (minutes)</mat-label>

                                    <input
                                       matInput
                                       autocomplete="off"
                                       type="number"
                                       [value]="extensionQueue?.announcementFrequency"
                                       formControlName="announcementFrequency"
                                       id="announcementFrequency"
                                       [required]="
                                          form.get('extensionQueue.isAnnounceWaitTime')?.value ||
                                          form.get('extensionQueue.isAnnounceQueueCount')?.value ||
                                          form.get('extensionQueue.isAnnounceCallback')?.value
                                       "
                                    />

                                    @if (form.get('extensionQueue.announcementFrequency')?.hasError('required')) {
                                    <mat-error> Frequency is Required. </mat-error>
                                    } @if ( form.get('extensionQueue.announcementFrequency')?.hasError('pattern') ||
                                    form.get('extensionQueue.announcementFrequency')?.hasError('min') ||
                                    form.get('extensionQueue.announcementFrequency')?.hasError('max') ) {
                                    <mat-error> Frequency must be a whole number between 1 and 10 minutes. </mat-error>
                                    }
                                 </mat-form-field>
                              </div>

                              <div class="flex-half default-announcements">
                                 <mat-checkbox
                                    [checked]="extensionQueue?.isAnnounceWaitTime"
                                    formControlName="isAnnounceWaitTime"
                                    id="isAnnounceWaitTime"
                                    (change)="onAnnounceTimeOptionChange($event)"
                                 >
                                    Wait Time
                                 </mat-checkbox>

                                 <mat-checkbox
                                    [checked]="extensionQueue?.isAnnounceQueueCount"
                                    formControlName="isAnnounceQueueCount"
                                    id="isAnnounceQueueCount"
                                    (change)="onAnnounceTimeOptionChange($event)"
                                 >
                                    Number of Callers Waiting
                                 </mat-checkbox>

                                 <mat-checkbox
                                    [checked]="extensionQueue?.isAnnounceCallback"
                                    formControlName="isAnnounceCallback"
                                    id="isAnnounceCallback"
                                    (change)="onAnnounceTimeOptionChange($event)"
                                 >
                                    Offer Callback Option
                                 </mat-checkbox>
                              </div>
                           </ndt-card>

                           <ndt-card [title]="'Custom Announcement Settings'" class="detail-card-half">
                              <mat-icon
                                 class="tooltip"
                                 header-action
                                 [appTooltip]="
                                    'Configure which custom announcements are played using the Custom Announcements section below.'
                                 "
                              >
                                 help
                              </mat-icon>

                              <mat-form-field class="flex-half announcement-frequency">
                                 <mat-label>Frequency (minutes)</mat-label>

                                 <input
                                    matInput
                                    autocomplete="off"
                                    type="number"
                                    formControlName="periodicAnnouncementFrequency"
                                 />

                                 @if ( form.get('extensionQueue.periodicAnnouncementFrequency')?.hasError('pattern') ||
                                 form.get('extensionQueue.periodicAnnouncementFrequency')?.hasError('min') ||
                                 form.get('extensionQueue.periodicAnnouncementFrequency')?.hasError('max') ) {
                                 <mat-error> Frequency must be a whole number between 1 and 10 minutes. </mat-error>
                                 }
                              </mat-form-field>
                           </ndt-card>
                        </div>

                        <div class="announcement-list-container">
                           <ndt-queue-periodic-announcement-list
                              [accountId]="extension.account?.accountId"
                              [callState]="callState"
                              [extensionPrivileges]="extensionPrivileges"
                              formControlName="queuePeriodicAnnouncements"
                              (addExistingPromptClick)="onAddExistingPeriodicAnnouncementPromptClick()"
                              (addNewPromptClick)="onAddNewPeriodicAnnouncementClick()"
                           ></ndt-queue-periodic-announcement-list>
                        </div>
                     </ng-container>
                  </div>
               </mat-tab>
               } @if ( extension && extension?.type?.name !== extensionTypes.VoiceMailbox && extension?.type?.name !==
               extensionTypes.SmartVoicemail && extension?.type?.name !== extensionTypes.Fax ) {
               <mat-tab [label]="'Inbound Call Rules'">
                  <div class="mat-tab-indented">
                     <ndt-extension-time-based-routes
                        [extensionPrivileges]="_extensionPrivileges"
                        [extension]="extension"
                        [callState]="callState"
                        [canEdit]="canEdit()"
                        formControlName="timeBasedRoutes"
                        (addTimeBasedRouteClick)="onAddTimeBasedRouteClick()"
                     ></ndt-extension-time-based-routes>
                  </div>
               </mat-tab>
               } @if (callDetailsPrivileges?.canView && extension && extension?.type?.name !== extensionTypes.Fax) {
               <mat-tab [label]="'Call Log'">
                  <ndt-call-logs-register
                     [extensionId]="extension?.extensionId"
                     [callDetailsPrivileges]="callDetailsPrivileges"
                  ></ndt-call-logs-register>
               </mat-tab>
               } @if ( (extension?.type?.name === extensionTypes.Phone || extension?.type?.name ===
               extensionTypes.VoiceMailbox || extension?.type?.name === extensionTypes.SmartVoicemail) && extension ) {
               <mat-tab [label]="'Mailbox'">
                  @if (extension) {
                  <div class="mat-tab-indented">
                     <ng-template mat-tab-label>
                        <span>Mailbox</span>

                        @if ( unreadMessageCount > 0 && extension?.type?.name !== extensionTypes.SmartVoicemail ) {
                        <span class="mailbox-tab-counter tooltip" matTooltip="Unread messages">
                           {{ (unreadMessageCount ?? 0) | formatMailboxMessageCount }}
                        </span>
                        }
                     </ng-template>

                     <ndt-mailbox-detail
                        [extensionPrivileges]="_extensionPrivileges"
                        [promptPrivileges]="_promptPrivileges"
                        [extensionType]="extension.type?.name"
                        [accountId]="extension.accountId"
                        [AccountOperatorExtension]="
                           extension?.account?.operatorExtension?.number +
                           ' - ' +
                           extension?.account?.operatorExtension?.name
                        "
                        [callState]="callState"
                        [extensionId]="extension?.extensionId"
                        [mailbox]="extension?.mailbox"
                        (unreadMessageCountChanged)="unreadMessageCount = $event"
                        formGroupName="mailbox"
                        (addNewPromptClick)="onAddNewVoiceMailGreetingPromptClick($event)"
                        (editMailboxPinClick)="onEditMailboxPinClick(extension?.mailbox)"
                     ></ndt-mailbox-detail>
                  </div>
                  }
               </mat-tab>
               }
            </mat-tab-group>
         </div>
      </ndt-two-column-layout>

      <ndt-form-footer (cancel)="onCancel()" [visible]="form.dirty" [callState]="callState">
         @if (form.get('extensionPhone.sipUsernames')?.hasError('uniqueSipUserName')) {
         <mat-error> SIP Users Require Unique Usernames. </mat-error>
         }
      </ndt-form-footer>
   </form>
</lcs-loading-overlay>

<mat-menu #extensionMenu="matMenu">
   @if ( extensionPrivileges?.canEditOthers && (extension?.type?.name === extensionTypes.Phone || extension?.type?.name
   === extensionTypes.VoiceMailbox) ) {
   <button mat-menu-item type="button" (click)="onEditMailboxPinClick()" id="menu-extension-edit-mailbox-pin">
      Change Mailbox PIN
   </button>
   } @if (canDelete()) {
   <button mat-menu-item type="button" (click)="onDeleteClick()" id="menu-extension-delete"> Delete </button>
   } @if ( (extension?.type?.name === extensionTypes.Phone || extension?.type?.name === extensionTypes.VoiceMailbox) &&
   extension ) {
   <button (click)="onResetMwiClick()" mat-menu-item type="button" id="menu-extension-reset-mwi"> Reset MWI </button>
   } @if ( isSystemUser && (extension?.type?.name === extensionTypes.Phone || extension?.type?.name ===
   extensionTypes.VoiceMailbox || extension?.type?.name === extensionTypes.SmartVoicemail) && extension &&
   canClearMailbox() ) {
   <button mat-menu-item type="button" id="menu-extension-clear-mailbox" (click)="clearMailbox()">
      Clear Mailbox
   </button>
   } @if ( isSystemUser && (extension?.type?.name === extensionTypes.Phone || extension?.type?.name ===
   extensionTypes.VoiceMailbox || extension?.type?.name === extensionTypes.SmartVoicemail) && extension &&
   canResetMailbox() ) {
   <button mat-menu-item type="button" id="menu-extension-reset-mailbox" (click)="resetMailbox()">
      Reset Mailbox
   </button>
   } @if (hackedFraudDetails && (hackedFraudDetails.isHacked || hackedFraudDetails.isFraud)) {
   <button
      mat-menu-item
      type="button"
      id="extension-details-reset"
      (click)="resetHackedAndFraudDetails(hackedFraudDetails)"
   >
      Resolve issue
   </button>
   }
</mat-menu>

<mat-menu #updateDetailsMenu="matMenu">
   <update-details
      [createUser]="_createUser"
      [createDate]="extension?.createDate"
      [updateUser]="_updateUser"
      [updateDate]="extension?.updateDate"
   ></update-details>
</mat-menu>
